<script setup lang="ts">
import searchIcon from '@/assets/icons/blog/plush/search.svg'

const props = defineProps<{
    url: string
}>()

const searchQuery = ref('')
function handleSearch() {
    if (searchQuery.value) {
        const url = `${props.url}${encodeURIComponent(searchQuery.value)}`
        window.location.href = url
    }
}
</script>

<template>
    <div class="relative flex h-12 w-full rounded md:w-1/2 lg:w-[400px]">
        <input
            v-model="searchQuery"
            type="search"
            placeholder="Szukaj"
            name="search"
            class="w-full rounded border-2 border-plush-primary bg-white p-3 text-plush-primary"
            @keyup.enter="handleSearch"
        />
        <NuxtLink
            :to="`${url}${encodeURIComponent(searchQuery)}`"
            class="absolute inset-y-0 right-0 flex !w-[52px] items-center justify-center rounded bg-plush-primary"
        >
            <AtomImage :src="searchIcon" />
        </NuxtLink>
    </div>
</template>
